import { NotificationPlacement } from "antd/es/notification/interface";
import { notification } from "antd";
import { BookyButton } from "../Buttons/BookyButton";
import { useEffect, useState } from "react";
import { CookieSettingsModal } from "./CookieSetingsModal";
import { CookieConcentInformation } from "../../Types/CookieConcentInformation";
import { useCookieConcent } from "../../Hooks/useCookieConcent";
import { TextService } from "../../Services/TextService";

export const CookieConcent = (props: any) => {
    const [api, contextHolder] = notification.useNotification();
    const { SaveCookieConcent, GetCookieConcent, ActivateGoogleAnalytics } = useCookieConcent();
    const [cookieConentInformation, setCookieConentInformation] = useState(null as CookieConcentInformation | null);
    const GetText = TextService.GetText;

    const onCookieSave = (cookieConcent: CookieConcentInformation) => {
        SaveCookieConcent(cookieConcent);
        setCookieConentInformation(cookieConcent);
        api.destroy();
    }


    const onAcceptAll = async () => {
        const savedConcent: CookieConcentInformation = {
            timeStamp: new Date(),
            functional: true,
            analytics: true
        }

        onCookieSave(savedConcent);
    }

    const onDenyAll = async () => {
        const savedConcent: CookieConcentInformation = {
            timeStamp: new Date(),
            functional: false,
            analytics: false
        }

        onCookieSave(savedConcent);
    }

    useEffect(() => {
        const cookieConcentInformation = GetCookieConcent();

        if (cookieConcentInformation?.analytics) {
            ActivateGoogleAnalytics();

        }
        if (cookieConcentInformation == null) {
            setCookieConentInformation(cookieConcentInformation);
            api.destroy();
            api.info({
                message: GetText("CookieSettingsModal_NotificationTitle"),
                duration: 0,
                description: <>{GetText("CookieSettingsModal_NotificationDescription")} <br /><br />
                    <div className="cookieContainer">
                        <div className="cookieAccept">
                            <BookyButton onClick={onAcceptAll} fullWidth text={GetText("CookieSettingsModal_AcceptAll")} />
                            <BookyButton onClick={onDenyAll} fullWidth type={"default"} text={GetText("CookieSettingsModal_OnlyNeccecary")} />
                        </div>
                        <div className="cookieSettings">
                            <CookieSettingsModal type={"default"} fullWidth text={GetText("CookieSettingsModal_Settings")} onCookieSave={onCookieSave} cookieConcent={cookieConcentInformation} />
                        </div></div></>,
                placement: "bottomLeft" as NotificationPlacement,
            });
        }
    }, [props]);


    return <>{contextHolder}</>

}